export enum trackingEvents {
    CLICK_QUICK_DEPOSIT = "click_quick_deposit",
    CLICK_DEPOSIT_CASHIER = "click_deposit_cashier",
}